export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_CUSTOMERS_PAGE = "SET_CUSTOMERS_PAGE";
export const SET_CUSTOMERS_SEARCH = "SET_CUSTOMERS_SEARCH";

export const SET_CUSTOMER_BOOKINGS = "SET_CUSTOMER_BOOKINGS";
export const SET_CUSTOMERS_LOADING = "SET_CUSTOMERS_LOADING";